import * as React from 'react'
import { QuestionDTO } from 'jobs/dtos/questions'
import Icon, { IconProps, IconName } from 'components/Icon'

/**
 * Makes an Icon component.
 *
 * @param name
 * @param color
 */
const makeIconComponent =
  (name: IconName, color: string) => (props: Partial<IconProps>) =>
    <Icon color={color} name={name} {...props} />

const unknown = makeIconComponent('legend-builder-breaker', '#000')
const icons: {
  [P in QuestionDTO['type']]: React.FC<
    React.PropsWithChildren<Partial<IconProps>>
  >
} = {
  BOOL: makeIconComponent('legend-builder-yes-no', '#007be7'),
  TEXT: makeIconComponent('legend-builder-text', '#5ab3ff'),
  NUMERIC: makeIconComponent('legend-builder-numeric', '#5ab3ff'),
  DATE_TIME: makeIconComponent('legend-builder-datetime', '#e91e63'),
  DOCUMENTS: makeIconComponent('legend-builder-document-upload', '#0967b9'),
  SELECT: makeIconComponent('legend-builder-choice', '#40a0f4'),
  BREAKER: makeIconComponent('legend-builder-breaker', '#645efe'),
}

/**
 * Question icon.
 */
export default function QuestionIcon({
  type,
  ...rest
}: Partial<IconProps> & { type: QuestionDTO['type'] | undefined | null }) {
  const IconComponent = (type && icons[type]) || unknown
  return <IconComponent {...rest} />
}
